export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/api/"
    : "http://localhost:8081/mathub/v8/";
